import type { Module } from "@webmotors/ioc";
import { GeolocationCookieService } from "./geolocation.service";
import { CookieModule } from "@packages/common";

export const GeolocationCookieModule: Module = {
  name: "GeolocationCookieModule",
  modules: [CookieModule],
  providers: [GeolocationCookieService],
};
